import * as React from 'react';

function SvgTickFilledSuccess(props) {
  const bgcolor = props.bgcolor ? props.bgcolor : 'currentColor';
  const color = props.color ? props.color : 'currentColor';
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M15 26.7C8.538 26.7 3.3 21.462 3.3 15 3.3 8.538 8.538 3.3 15 3.3c6.462 0 11.7 5.238 11.7 11.7 0 6.462-5.238 11.7-11.7 11.7z"
        fill={bgcolor}
      />
      <path
        d="M21.274 11.246a.525.525 0 11.737.75l-8.604 8.457c-.204.201-.531.201-.736 0L8.99 16.838a.525.525 0 01.735-.75l3.314 3.256 8.236-8.097z"
        fill={color}
      />
    </svg>
  );
}

export default SvgTickFilledSuccess;
